


























import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedBusinessNumber: {
                num: null
            }
        }
    },
    computed: {
        validBusinessNumber(): boolean {
            let number = this.selectedBusinessNumber.num
            if (number == null) {
                return false
            }
            //  Length including numbers, characters, and spaces
            if (number.length === 14) {
                return true
            }
            return false
        }
    },
    methods: {
        popInvalid(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Invalid Phone Number',
                text: 'That phone number is invalid or unreachable.',
                icon: 'mdi-alert-circle'
            })
            //  Reset form field
            this.selectedBusinessNumber.num = null
        },
        async verifyBusinessNumber(): Promise<void> {
            //  Validate the form
            const valid = this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Start the loading spinner
            this.loading = true

            // We need to format the number to international format (i.e 17753451234)
            // Removes non-numeric characters and replaces them with an empty string (not a space but a value like '')
            let semiFormttedNumber  = this.selectedBusinessNumber.num.replace(/\D/g, '');
            
            // Add country code
            const internationalFormattedNumber = '1' + semiFormttedNumber;

            //  Stop the loading spinner
            this.loading = false

            //  Else, update the nexmo account with the valid forwarding number
            const account = await this.$store.dispatch('smsAccountForward', {
                num: internationalFormattedNumber,
            })

            //  If the request failed, do nothing
            if (!account) return

            //  Else, emit success to parent
            this.$emit('submit', true)
        }
    }
})
